import apiClient from '@/services/apiClient';

const B = '/jobber-master';
const d = (p) => p.then((r) => r.data);

const saveBlob = (blob, name) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = name; a.click();
  URL.revokeObjectURL(url);
};

const download = async (path, name) => {
  const r = await apiClient.get(`${B}${path}`, { responseType: 'blob' });
  saveBlob(r.data, name);
};

export const jobberSlug = (s) => String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

export const jobberMasterApi = {
  list: () => d(apiClient.get(B)),
  active: () => d(apiClient.get(`${B}/active`)).then((r) => r.jobbers || []),
  states: () => d(apiClient.get(`${B}/states`)).then((r) => r.states || []),
  get: (id) => d(apiClient.get(`${B}/${encodeURIComponent(id)}`)),
  create: (body) => d(apiClient.post(B, body)),
  update: (id, body) => d(apiClient.put(`${B}/${encodeURIComponent(id)}`, body)),
  setActive: (id, active) => d(apiClient.patch(`${B}/${encodeURIComponent(id)}/active`, { active })),
  upload: (file) => {
    const form = new FormData();
    form.append('file', file);
    return d(apiClient.post(`${B}/upload`, form, { headers: { 'Content-Type': 'multipart/form-data' } }));
  },
  template: () => download('/template', 'jobber_master_template.xlsx'),
  exportXlsx: () => download('/export', `jobber_master_${new Date().toISOString().slice(0, 10)}.xlsx`),
};
